// http-response.interceptor.ts
import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpResponse
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { JWTTokenServiceService } from 'src/app/public/services/token.service';

export const HttpResponseInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const tokenService = inject(JWTTokenServiceService);
  const token = tokenService.getToken();

  request = request.clone({
    headers: request.headers.set('Authorization', `Bearer ${token}`)
  });

  return next(request).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse && event.status === 200) {
          // Optional: Handle success
        }
      },
      error: (error) => {
        let errorMsg = '';
        if (error.error instanceof ErrorEvent) {
          console.log('Client side error:', error.error.message);
        } else {
          console.log(`Error Code: ${error.status}, Message: ${error.message}`);
        }
      }
    })
  );
};
